import { render, staticRenderFns } from "./CreateArticle.vue?vue&type=template&id=768600a5"
import script from "./CreateArticle.vue?vue&type=script&lang=js"
export * from "./CreateArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports